
export default class Util {
    static deleteCookie( name, path ) {
        if (Util.getCookie(name)) {
        document.cookie = name + "=" +
            ((path) ? ";path="+path:"")+
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
        }
    }

    static getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return "";
    }

    static setCookie(name, value) {
        // Set a cookie named "username" with the value "John Doe" that expires in 7 days
        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 days in milliseconds
        document.cookie = name+"="+value+"; expires=" + expirationDate.toUTCString() + "; path=/";
    }

    static formatDate(datetimeStr) {
        if (!datetimeStr) return "";

        let date = null;

        if (datetimeStr instanceof Date) {
            date = datetimeStr;
        } else if (typeof datetimeStr === "string" && /^\d{14}$/.test(datetimeStr)) {
            const year = datetimeStr.slice(0, 4);
            const month = datetimeStr.slice(4, 6);
            const day = datetimeStr.slice(6, 8);
            const hour = datetimeStr.slice(8, 10);
            const minute = datetimeStr.slice(10, 12);
            const second = datetimeStr.slice(12, 14);
            date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
        } else {
            date = new Date(datetimeStr);
        }

        if (Number.isNaN(date.getTime())) {
            return String(datetimeStr);
        }

        return date.toLocaleString(); // or toLocaleDateString(), toLocaleTimeString(), etc.
    }
}
